<template>
    <div class="row row-wizard">
        <div class="col-md-12 fuelux">
            <div class="block-wizard">
                <div class="wizard wizard-ux">
                    <div class="steps-container">
                        <slot name="steps"/>
                    </div>
                    <div class="actions" v-if="!!$slots.actions">
                        <slot name="actions"/>
                    </div>
                    <div class="step-content">
                        <div class="step-pane active">
                            <slot/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    };
</script>

<style lang="scss">
    .wizard-ux {
        overflow: visible !important;
    }
</style>
